export type Bonus = {
  number: string
  title: string
  price: string
  body: string
  cover: string
}

export const bonuses: Bonus[] = [
  {
    number: '01',
    title: 'The First Reset: Your 20-Minute Install',
    price: '$9',
    body: 'One sheet, printed on one side. Not a guide about the kit — a path through it. Pick your paper, print three pages, write three anchors in pencil, hang the page, set a timer for twenty minutes and run your first reset. Day one ends with something on the fridge and one reset done, and everything else gets read later, out of curiosity instead of obligation.',
    cover:
      'https://cdn.magicpatterns.com/uploads/1Bk1RwBTveKFuGG2gru9q3/bonus-1.webp',
  },
  {
    number: '02',
    title: 'The Sideways Season Kit',
    price: '$19',
    body: 'The hard-season machinery — the Minimum Viable Week, the Simplify Ladder, the derailed-day protocol, and the re-entry sheet — pulled out of three volumes and put in one place you can reach without looking. You fill it on a good day, store it beside the Command Center, and find it already loaded on the night you need it.',
    cover:
      'https://cdn.magicpatterns.com/uploads/947bNPSzwq8vB7JzMTdCJh/Bonus-2.webp',
  },
  {
    number: '03',
    title: 'The Wall Pack',
    price: '$19',
    body: 'The eight pieces that belong on a wall rather than in a binder, re-laid one file per piece at the size the piece actually wants: the Command Center, the Weekly Reset Checklist, the anchor and routine cards ready to cut apart, the Derailed-Day card, the Paper Flow Map, the Simplify Ladder. Same words, sized to be read from across a room.',
    cover:
      'https://cdn.magicpatterns.com/uploads/bTptT6g1fYrUYJN4BboTvp/Bonus-3.webp',
  },
  {
    number: '04',
    title: 'The Refill Pack',
    price: '$17',
    body: 'Fifty-three reprintable masters, each in its own file, organized by cadence — weekly, per block, monthly, yearly, as needed. No more opening the right PDF, hunting the page number and setting a print range every single Sunday. The pages are identical to the ones in the volumes; the difference is that you find them in four seconds.',
    cover:
      'https://cdn.magicpatterns.com/uploads/ibZkamsU9otXTqtwiHdxFv/Bonus-4.webp',
  },
  {
    number: '05',
    title: 'The Handoff Sheet',
    price: '$15',
    body: 'One page for the ordinary day you’re not there for — an appointment, a bad flu, a trip. The one thing that has to happen, where things live, what the kids already run themselves, what to do if the day goes sideways, and what nobody needs to worry about. Because everything is already written down, handing off stops being explaining and becomes handing someone a page.',
    cover:
      'https://cdn.magicpatterns.com/uploads/97YQb9FUeSvfnfeDKr2xNA/Bonus-5.webp',
  },
]
